/**
 * Strukturální zod schéma grafu (tvar nodes/edges). Per-uzlové parametry validuje
 * validateGraph.ts přes NODE_PARAM_SCHEMAS z registru (až po strukturální kontrole).
 */

import { z } from "zod";

const nodeSchema = z.object({
  id: z.string().min(1).max(64),
  /** Typ se proti registru ověřuje až ve validateGraph (lepší chybová hláška než zod enum). */
  type: z.string().min(1).max(64),
  params: z.record(z.string(), z.unknown()),
  position: z.object({ x: z.number(), y: z.number() }),
  label: z.string().max(120).optional(),
  meta: z.record(z.string(), z.unknown()).optional(),
});

const edgeSchema = z.object({
  id: z.string().min(1).max(96),
  source: z.string().min(1),
  sourceHandle: z.string().min(1),
  target: z.string().min(1),
  targetHandle: z.string().min(1),
});

export const automationGraphSchema = z.object({
  schemaVersion: z.literal(1),
  nodes: z.array(nodeSchema).max(200),
  edges: z.array(edgeSchema).max(600),
});

export type AutomationGraphInput = z.infer<typeof automationGraphSchema>;
